import { HttpClient } from '@angular/common/http';
import { Component, NgModule, OnInit } from '@angular/core';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { Router } from '@angular/router';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-crear-cliente',
    templateUrl: './crear-cliente.component.html',
    styleUrls: ['./crear-cliente.component.css'],
    standalone: true,
    imports: [ReactiveFormsModule,CommonModule,FormsModule]
})
export class CrearClienteComponent implements OnInit {
  loading = false;
  error = '';
  cliente = {
    nombre: '',
    telefono: '',
    email:''
  };

  constructor(
    private http: HttpClient,
    private clienteService: ClienteService,
    private currentUserService: CurrentUserService,
    private router: Router
  ) {}

  guardarCliente(): void {
    const usuarioId = this.currentUserService.getUsuarioId();
    if (!usuarioId) {
      alert('Debes iniciar sesión para acceder a esta sección.');
      this.router.navigate(['/login']);
      return;
    }
    this.clienteService.guardarCliente(usuarioId,this.cliente).subscribe({ 
      next: (response) => {
        if (response) {
          alert('Cliente creado exitosamente');
          this.router.navigate(['/cliente']);
        }
      },
      error: () => {
        this.error = 'Error al crear el cliente. Por favor, inténtalo de nuevo.';
        this.loading = false;
      },
    });
  }
  volverAtras(): void {
    this.router.navigate(['/cliente']); 
  }
  ngOnInit(): void {
  }

}
